import _ from 'lodash';
import React, { useEffect } from 'react';

import { useRestContext } from 'scbk-services/http';
import { changeI18nLanguage } from 'scbk-services/i18n';
import { useAppContext } from 'scbk-services/shared-context';

import { Languages } from 'scbk-services/config/enums/languages';
import { useLocaleStore } from 'scbk-services/config/stores/localeStore';
import { getUrlParameter } from 'scbk-services/utils';

const useLocale = () => {
    const { updateContext: updateAppContext } = useAppContext();
    const { updateContext: updateRestContext } = useRestContext();

    const setStoreLocale = useLocaleStore((state) => state.setLocale);
    const getLocale = useLocaleStore((state) => state.getLocale);

    const getPreDefinedLocale = () => {
        // First, get pre-defined locale from url params
        const localeParam = getUrlParameter('locale');
        if (
            !_.isEmpty(localeParam) &&
            Object.values(Languages).includes(localeParam as Languages)
        ) {
            return localeParam as Languages;
        }

        return getLocale();
    };

    const setLocale = (locale: Languages) => {
        const currentLocale = getLocale();
        let finalLocale = currentLocale;

        // 유효한 언어값인지 체크
        if (!_.isEmpty(locale) && Object.values(Languages).includes(locale as Languages)) {
            finalLocale = locale;
        }

        // Context/Store
        updateAppContext({ language: finalLocale });
        updateRestContext({ locale: finalLocale });
        setStoreLocale(finalLocale);

        // 현재언어설정과 동일할경우 return
        if (currentLocale === finalLocale) {
            return;
        }

        // i18m 언어 변경
        changeI18nLanguage(finalLocale);
        // document lang 변경
        document.documentElement.lang = finalLocale;
    };

    const useSubscribeLocale = (
        callback: (locale: string) => void,
        dependencies: React.DependencyList = [],
    ) => {
        useEffect(() => {
            const unsubscribe = useLocaleStore.subscribe((state) => {
                callback(state.currentLocale);
            });
            return () => unsubscribe();
        }, [...dependencies]);
    };

    return { getPreDefinedLocale, getLocale, setLocale, useSubscribeLocale };
};

export { useLocale };
